import HubLayout from './HubLayout'
export default HubLayout
